<template>
    <b-form-row>
        <b-form-group :label="label"
                      label-for="contactNames"
                      class="col">
            <b-input-group>
                <select2 name="contactNames"
                         disabled
                         multiple
                         :options="contacts"
                         key-property="contactId"
                         text-property="name"
                         v-model="contactIds"></select2>
                <b-input-group-append>
                    <b-button variant="outline-secondary" v-b-tooltip :title="(contacts && contacts.length) ? 'Display Contact Details' : ''" :disabled="!(contacts && contacts.length)" v-on:click="contactDetailsOpen = true"><i class="fas fa-address-card"></i></b-button>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
        <b-modal size="md" centered title="Contact Details" ok-only ok-title="Close" v-model="contactDetailsOpen">
            <b-list-group flush>
                <b-list-group-item v-for="contact in contacts" :key="contact.contactId">
                    <div class="font-weight-bold">{{ contact.name }}</div>
                    <div v-if="(contact.email != null)"><a :href="'mailto:' + contact.email">{{ contact.email }}</a></div>
                    <div v-if="(contact.phone != null)">{{ contact.phone }}</div>
                    <div v-if="(contact.address1 != null)">{{ contact.address1 + (contact.address2 ? (', ' + contact.address2) : '') }}</div>
                    <div v-if="(contact.suburb != null)">{{ contact.suburb + (contact.state ? (' ' + contact.state) : '') + (contact.postcode ? (' ' + contact.postcode) : '') + (contact.country ? (' ' + contact.country) : '') }}</div>
                </b-list-group-item>
            </b-list-group>
        </b-modal>
    </b-form-row>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    
    import Select2 from './Select2';

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);

    export default {
        name: 'Contacts',
        props: {
            label: {
                type: String,
                default: 'Contacts'
            },
            contacts: {
                type: Array,
                default: null
            }
        },
        data: function () {
            return {
                contactDetailsOpen: false
            };
        },
        computed: {
            contactIds() {
                var contactIds = [];
                if (this.contacts != null) {
                    this.contacts.forEach(contact => {
                        contactIds.push(contact.contactId);
                    });
                }
                return contactIds;
            }
        }
    }
</script>